import { graphql } from 'gatsby';
import React from 'react';
import Layout from '../../shared/components/organisms/layout/layout';
import SEO from "../../shared/seo";
import { siteUrl } from '../../shared/utils/siteUrl';
import { unicodeUtil } from '../../shared/utils/unicodeUtil';
import useMediaQuery from '../../shared/utils/useMediaQuery';
import { createAlternates } from '../../utils/alternateUtil';
import ProductContent from '../organisms/product-content/product-content';

const ProductTemplate = (props) => {

  const { pageContext } = props;
  const { params: productoInfo } = pageContext;
  // send active modal to layout
  const [modalActive, setModalActive] = React.useState();
  // var news_info=props.dataProp
  const isMobile = useMediaQuery()
  
  const alternates = createAlternates({
    contentInfo: props.data.allContentfulNolProductos.nodes,
    countries: props.data.allContentfulNolPaises.nodes,
    category: "productos/"
  })

  React.useEffect(() => {
    let body = document.getElementsByTagName("body")[0]
    let html = document.getElementsByTagName("html")[0]

    if (modalActive) {
      body.classList.add("overflow-body-hidden")
      html.classList.add("overflow-body-hidden")
    } else {
      body.classList.remove("overflow-body-hidden")
      html.classList.remove("overflow-body-hidden")
    }

  }, [modalActive]);

  const seoImg = productoInfo?.metaImagen?.file?.url
    ? "https:" + productoInfo.metaImagen.file.url
    : ""

  let schemaOrgJSONLD = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "url": siteUrl + '/productos/' + pageContext.grandPaternSlug + "/" + pageContext.paternSlug + "/" + productoInfo.slug,
    "name": unicodeUtil(productoInfo.metaTitulo),
    "description": unicodeUtil(productoInfo.metaDescripcion.metaDescripcion.split("\n")[0]),
    "image": seoImg,
    "sku": productoInfo.codigoDeProducto,
    "mpn": productoInfo.codigoDeProducto,
    "brand": {
      "@type": "Thing",
      "name": "NosotrasOnline"
    },
    "review": {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Organization",
        "name": "NosotrasOnline"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": 1
    }
  };

  return (
    <Layout
      mobile={isMobile}
      modalActive={modalActive}
      title={productoInfo.metaTitulo}
    >
      <SEO
        title={productoInfo.metaTitulo}
        description={productoInfo.metaDescripcion.metaDescripcion.split("\n")[0]}
        lang={productoInfo.node_locale}
        image={seoImg}
        url={`/productos/${pageContext.grandPaternSlug}/${pageContext.paternSlug}/${productoInfo.slug}`}
        script={schemaOrgJSONLD}
        alternates={alternates}
      />
      <ProductContent context={pageContext} setModalActive={setModalActive}  mobile={isMobile} />
    </Layout>
  )
}

export const query = graphql`
  query GET_PRODUCT_INFO($contentful_id: String!) {
    allContentfulNolProductos(
      filter: { contentful_id: { eq: $contentful_id } }
    ) {
      nodes {
        slug
        contentful_id
        updatedAt
        node_locale
        paisesDeRestriccionDelProducto
      }
    }
    allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
      nodes {
        dominioDelPais
        codigoIcu
      }
    }
  }
`

export default ProductTemplate;
